import { z } from "zod";

export const OneClickUpsellGlobalSettingsDtoSchema = z.object({});

export type OneClickUpsellGlobalSettingsDto = z.infer<
  typeof OneClickUpsellGlobalSettingsDtoSchema
>;
export type OneClickUpsellExperienceSettingsDto = object;
